import { colors } from '../../../tokens/colors'

export const getContrastSafeColor = (backgroundColor: string) => {
  // Remove the hash, if present
  backgroundColor = backgroundColor.replace(/^#/, '')
  // Validate hex string
  const isValidHex = /^[0-9A-Fa-f]{6}$|^[0-9A-Fa-f]{3}$/.test(backgroundColor)
  if (!isValidHex) {
    return colors.copy.paragraphDark
  }
  // Parse hex to RGB
  let bigint = parseInt(backgroundColor, 16)
  let r = (bigint >> 16) & 255
  let g = (bigint >> 8) & 255
  let b = bigint & 255

  const sum = Math.round((r * 299 + g * 587 + b * 114) / 1000)
  return !!sum && sum > 128
    ? colors.copy.paragraphDark
    : colors.copy.paragraphLight
}

export const getIsLightBackground = (bgColor?: string) => {
  if (!bgColor) {
    return true
  }
  // Remove the hash, if present
  const backgroundColor = bgColor.replace(/^#/, '')
  // Validate hex string
  const isValidHex = /^[0-9A-Fa-f]{6}$|^[0-9A-Fa-f]{3}$/.test(backgroundColor)
  if (!isValidHex) {
    return true
  }
  // Parse hex to RGB
  const bigint = parseInt(backgroundColor, 16)
  const r = (bigint >> 16) & 255
  const g = (bigint >> 8) & 255
  const b = bigint & 255

  const sum = Math.round((r * 299 + g * 587 + b * 114) / 1000)
  return Boolean(!!sum && sum > 128)
}

export const getStringType = (value: string) => {
  value = value.replace(/,/g, '')
  if (value.startsWith('$') && !isNaN(Number(value.slice(1)))) {
    return 'CURRENCY'
  } else if (/^\d+%$/.test(value)) {
    return 'PERCENTAGE'
  } else if (value.length > 0 && !isNaN(Number(value))) {
    return 'NUMBER'
  }

  return 'STRING'
}

export const draftJsOptionsObject = {
  entityStyleFn: (entity: any) => {
    if (entity.get('type').toLowerCase() === 'link') {
      const data = entity.getData()
      return {
        element: 'a',
        attributes: {
          href: data.url,
          target: data.targetOption,
        },
      }
    }
    return {}
  },
  blockStyleFn: (block: any) => {
    const data = block.getData()
    if (data.size === 0) return {}

    let style = {}
    if (data.get('text-align'))
      style = { ...style, textAlign: data.get('text-align') }
    return { style }
  },
}
